import { User } from "./user";

export enum Frequency {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

export interface RecurrencePattern {
  id: string;
  organizationDriverAvailabilitySlotId: string;
  frequency: Frequency;
  interval: number;
  count: number | null;
  endDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OrganizationDriverAvailabilitySlot {
  id: string;
  userId: string;
  startTime: string;
  endTime: string;
  isRecurring: boolean;
  createdAt: string;
  updatedAt: string;
  recurrence: RecurrencePattern | null;
  user: User;
}
